// extracted by mini-css-extract-plugin
export default {"root":"TrustIndicators-root","title":"TrustIndicators-title","trustIndicators":"TrustIndicators-trustIndicators"};